var map = {
	"./apple-appstore-badge-2018.svg": 969,
	"./esyoil-rating-gray.svg": 755,
	"./esyoil-rating.svg": 970,
	"./google-play-badge-2018.svg": 971,
	"./logo-reduced.svg": 972,
	"./logo.svg": 973,
	"./medaille.svg": 974,
	"./rakete.svg": 975,
	"./twitter-icon.svg": 285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;